var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const Svg2FadeBullet = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.864258,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#B0B0B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1349 16V15.233L13.0155 12.0795C13.3536 11.7102 13.632 11.3892 13.8508 11.1165C14.0695 10.8409 14.2314 10.5824 14.3366 10.3409C14.4445 10.0966 14.4985 9.84091 14.4985 9.57386C14.4985 9.26705 14.4246 9.00142 14.2769 8.77699C14.132 8.55256 13.9331 8.37926 13.6803 8.2571C13.4275 8.13494 13.1434 8.07386 12.828 8.07386C12.4928 8.07386 12.2002 8.14347 11.9502 8.28267C11.703 8.41903 11.5113 8.6108 11.3749 8.85795C11.2414 9.10511 11.1746 9.39489 11.1746 9.72727H10.1689C10.1689 9.21591 10.2868 8.76705 10.5226 8.38068C10.7584 7.99432 11.0795 7.69318 11.4857 7.47727C11.8948 7.26136 12.3536 7.15341 12.8621 7.15341C13.3735 7.15341 13.8266 7.26136 14.2215 7.47727C14.6164 7.69318 14.926 7.98437 15.1505 8.35085C15.3749 8.71733 15.4871 9.125 15.4871 9.57386C15.4871 9.89489 15.4289 10.2088 15.3124 10.5156C15.1988 10.8196 14.9999 11.1591 14.7158 11.5341C14.4346 11.9062 14.0439 12.3608 13.5439 12.8977L11.5837 14.9943V15.0625H15.6405V16H10.1349Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Svg2FadeBullet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/2-fade-bullet.3ca0f70d.svg";
export { ForwardRef as ReactComponent };